"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M7.8 7.2 9 10H7L5.87 7.33H4V10H2V2h7v5.2zM7 4H4v1.33h3z"
}), 'RMobiledataSharp');